/**
 * 서버 주소를 정한다.
 *
 * 웹은 프론트와 서버가 같은 오리진이라 상대 경로로 충분하다.
 * 데스크톱은 file://로 로드되므로 오리진이 없다 — 빌드 시점에
 * VITE_SERVER_URL로 알려줘야 한다.
 */

const configured = import.meta.env['VITE_SERVER_URL'] as string | undefined;

function origin(): string {
  if (configured) return configured.replace(/\/$/, '');

  if (location.protocol === 'file:') {
    throw new Error(
      '데스크톱 빌드에는 VITE_SERVER_URL이 필요합니다. 서버 주소를 지정하고 다시 빌드하세요.',
    );
  }
  return location.origin;
}

export function apiUrl(path: string): string {
  return `${origin()}${path}`;
}

export function roomSocketUrl(code: string): string {
  const base = origin();
  // http(s) → ws(s). 이미 ws로 지정된 경우는 그대로 둔다.
  const wsBase = base.replace(/^http/, 'ws');
  return `${wsBase}/r/${encodeURIComponent(code)}/ws`;
}
